
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/in/art/[id]",
      function () {
        return require("private-next-pages/in/art/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/in/art/[id]"])
      });
    }
  